/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 (original work) Open Assessment Technologies SA
 */

import pageController from '@/core/page/page';
import Monitoring from '@/component/monitoring/Monitoring.svelte';

export default () =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pageController({
        name: 'monitoring',
        /**
         * Renders monitoring page on success.
         * On error, either redirects to return_url if provided on JWT or to proctoring error page.
         * If error is not handled, displays error popup.
         */
        start() {
            // init Monitoring component
            this.component = new Monitoring({
                target: this.container,
                props: {
                    initialSortBy: 'progressPercentage'
                }
            });
        }
    });
